module.exports = __webpack_public_path__ + "img/9788925538686.42f251ba.jpg";